const getAppConfig = () => (window.App) || {};

export {
  getAppConfig,
};
